// eslint-disable-next-line consistent-return
export const currencyFormatDE = (num) => {
  if (num !== undefined && num !== null) {
    return num
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
};
// eslint-disable-next-line consistent-return
export const currencyFormatTriDec = (num) => {
  if (num !== undefined && num !== null) {
    return num
      .toFixed(3)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
};
// eslint-disable-next-line consistent-return
export const hiljadeFormat = (num) => {
  console.log('Broj za hiljade', num);
  if (num !== undefined && num !== null && num !== '') {
    return num
      .toFixed(0)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }
  return '';
};
